import { render } from "./NewMembersView.vue?vue&type=template&id=0acaacd3&scoped=true"
import script from "./NewMembersView.vue?vue&type=script&lang=js"
export * from "./NewMembersView.vue?vue&type=script&lang=js"

import "./NewMembersView.vue?vue&type=style&index=0&id=0acaacd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0acaacd3"]])

export default __exports__